var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C11.7346 17 11.4933 16.9059 11.3003 16.7178L5.26848 10.6024C4.90657 10.2261 4.90657 9.63807 5.2926 9.26174C5.67864 8.90893 6.28184 8.90893 6.66788 9.28526L12 14.695L17.3322 9.28526C17.6941 8.90893 18.3214 8.90893 18.7074 9.26174C19.0934 9.61455 19.0934 10.2261 18.7315 10.6024L12.6997 16.7178C12.5067 16.9059 12.2654 17 12 17Z",
    fill: "#2C3D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDown);
export default __webpack_public_path__ + "static/media/vector-down.3dc781f43c244c3084669f30e698cac7.svg";
export { ForwardRef as ReactComponent };